exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-green[data-v-ada85876]{background: #57be6a;}\n", ""]);

// exports
